import { useEffect, useState } from 'react'

import { useAppDispatch } from 'store'
import { TypeTicketCollectionActions } from 'store/pages/typeticketcollection'

interface Props {
  typeticketIds: number[]
}

const useBulkCollectionTypeticketData = (props: Props) => {
  const { typeticketIds } = props

  const dispatch = useAppDispatch()

  const [typeticketsFetchedAlready, setTypeticketsFetchedAlready] = useState<boolean>(false)

  useEffect(() => {
    if (!typeticketsFetchedAlready) {
      dispatch(TypeTicketCollectionActions.getBulkData({ ids: typeticketIds }))
      setTypeticketsFetchedAlready(true)
    }
  }, [typeticketIds])

}

export default useBulkCollectionTypeticketData
